/* Small play/pause button overlay for podcast feed items. */

import { Pause, Play } from "lucide-react";
import { useAudioPlayer } from "@/hooks/useAudioPlayer";
import type { PodcastTrack } from "@/types/audioPlayer";

interface PodcastPlayButtonProps {
  track: PodcastTrack;
}

export function PodcastPlayButton({ track }: PodcastPlayButtonProps) {
  const { state, play, togglePlayPause } = useAudioPlayer();
  const isThisTrack = state.track?.feedItemId === track.feedItemId;
  const isPlaying = isThisTrack && state.playbackState === "playing";

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    if (isThisTrack) {
      togglePlayPause();
    } else {
      play(track);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      onMouseDown={(e) => e.stopPropagation()}
      className="absolute inset-0 flex items-center justify-center bg-black/40 rounded-sm opacity-0 group-hover:opacity-100 hover:opacity-100 transition-opacity"
      style={isThisTrack ? { opacity: 1 } : undefined}
    >
      <div className="size-10 rounded-full bg-primary/90 flex items-center justify-center shadow-md">
        {isPlaying ? (
          <Pause className="size-5 text-primary-foreground fill-current" />
        ) : (
          <Play className="size-5 text-primary-foreground fill-current ml-0.5" />
        )}
      </div>
    </button>
  );
}
